import { els, breakpoints } from './variables';

const glossary = {
	init() {
		this.el = document.querySelector('.em-glossary');
		if (this.el) {
			this.nav = this.el.querySelector('.em-glossary__nav');
			this.navInner = this.nav.querySelector('ul');
			this.headers = this.el.querySelectorAll('.em-glossary__terms-header');

			this.updateOffsets = this.updateOffsets.bind(this);
			document.addEventListener('DOMContentLoaded', this.updateOffsets);
			window.addEventListener('resize', this.updateOffsets);
		}
	},

	updateOffsets() {
		window.requestAnimationFrame(() => {
			const headerHeight = els.header.classList.contains('has-notice') ? els.header.offsetHeight : els.headerInner.offsetHeight;
			if (breakpoints.sm.aboveMin()) {
				this.nav.style.top = `${headerHeight}px`;
			} else {
				this.navInner.style.top = `${headerHeight}px`;
				this.navInner.style.maxHeight = `${window.innerHeight - headerHeight}px`;
			}

			this.headers.forEach((header) => {
				header.style.top = breakpoints.sm.aboveMin() ? `${headerHeight + this.nav.offsetHeight}px` : `${headerHeight}px`;
			});
		});
	},
};

glossary.init();
